'use client';

import { useEffect } from 'react';
import { Field } from '../field/field.tsx';
import { useCreditCardFields } from './utils.ts';
export const CardTypeField: React.FC<{
  name: string;
}> = ({
  name
}) => {
  const {
    card
  } = useCreditCardFields();
  return <Field fieldClasses="hidden" name={name}>
      {({
      controlProps,
      formMethods
    }) => {
      // eslint-disable-next-line @eslint-react/rules-of-hooks
      useEffect(() => {
        if (card?.type) {
          formMethods?.setValue(name, card.type);
        }
      }, [card?.type]);
      return <input type="hidden" {...controlProps} ref={node => {
        if (!node) {
          return;
        }
        if (controlProps.ref) {
          controlProps.ref(node);
        }
      }} />;
    }}
    </Field>;
};